import 'react-app-polyfill/stable'; // core-js polyfills for older evergreen browsers

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './compat'
import { Provider } from 'react-redux';

import store from "./store";
import { loadData } from "./util";

const root = createRoot(document.getElementById('comment-root'));
root.render(
	<Provider store={store}>
		<App />
	</Provider>
);

loadData(store);